// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"33bd2eed","551":"fbafe096","665":"19f2220a","748":"7b8b4928","896":"93fa33e9"}[chunkId] + ".chunk.js";
};